import {Component, Input, OnInit} from '@angular/core';
import {PlayerService} from '../../player';
import {ArtistService, ScrollService, SongsService, ScrollParams, PlaylistService} from '../../api/';
import * as _ from 'lodash';
import {BlockUI, NgBlockUI} from 'ng-block-ui';

@Component({
    selector: 'add-to-queue',
    templateUrl: './add-to-queue.component.html',
    styleUrls: ['./add-to-queue.component.css']
})
export class AddToQueueComponent implements OnInit {
    @Input() song: any;
    @Input() playlist: any;
    // @Input() songs: any;
    @Input() queCheck: any = false;
    private songs: any = new Array<any>();
    artist: any;
    private isAlreadyInPlaylist = false;
    private scrollParams = new ScrollParams();
    @BlockUI() blockUI: NgBlockUI;
    public onlineOffline1: boolean = navigator.onLine;

    // private scrollSubscriber = null;
    constructor(private playerService: PlayerService, private songsService: SongsService, private playlistService: PlaylistService, private scrollService: ScrollService, private artistService: ArtistService) {
        window.addEventListener('online', () => {this.onlineOffline1 = true; });
        window.addEventListener('offline', () => {this.onlineOffline1 = false});
        this.playerService.isSongInQueue.subscribe(res => {
            this.song = res;
            if(this.song) {
                if(this.song.type != "R") {
                    this.isAlreadyInPlaylist = this.playerService.isTrackAlreadyInQueue(this.song);//setting up for the first time...
                    this.playerService.playerEvent.subscribe((event) => {
                        if(event.type === 'player:playlist') {
                            this.isAlreadyInPlaylist = this.playerService.isTrackAlreadyInQueue(this.song);
                        }
                    });
                }
            }
        })
    }

    ngOnInit() {
        this.songs.length = 0;

        if (this.song) {
            if (this.song.type != "R") {
                this.isAlreadyInPlaylist = this.playerService.isTrackAlreadyInQueue(this.song);//setting up for the first time...
                this.playerService.playerEvent.subscribe((event) => {
                    if (event.type === 'player:playlist') {
                        this.isAlreadyInPlaylist = this.playerService.isTrackAlreadyInQueue(this.song);
                    }
                });
            }
        }

        if (this.song) {
            if (this.song._type == 'artist') {
                this.artist = this.song;
            }
            if (this.song._type == 'playlist') {
                this.playlist = this.song;
                this.isAlreadyInPlaylist = this.playerService.isPlaylistAlreadyInQueue(this.song);
            }
        }


    }

    getTracks(type = true) {
        this.blockUI.start('Loading, please wait...');
        if (this.artist) {
            this.scrollService.toggleProgressBar(true);
            this.artistService.getArtistTracks(this.scrollParams.page, this.artist.id).subscribe((artistSongs) => {
                artistSongs.forEach((song) => {
                    song.playedFrom = 'artist';

                    this.songs.push(song);
                });
                this.songs = _.uniqBy(this.songs, 'id');
                this.scrollParams.page++;
                this.scrollService.toggleProgressBar(false);
                if (type) {
                    this.addTrack();
                } else {
                    this.removeTracks();
                }

                this.blockUI.stop();
            });
        }

        if (this.playlist) {
            this.scrollService.toggleProgressBar(true);
            this.playlistService.getPlaylistSongs(this.playlist.id).subscribe((songs) => {
                if (songs) {
                    songs.forEach((song) => {
                        song.playedFrom = 'playlist';
                        this.songs.push(song);
                    });
                }
                this.songs = _.uniqBy(this.songs, 'id');
                this.scrollService.toggleProgressBar(false);
                if (type) {
                    this.addTrack();
                    this.playerService.playlistList.push(this.playlist)
                } else {
                    this.removeTracks();
                    this.playerService.removePlaylist(this.playlist.id);
                }
                this.blockUI.stop();
            });
        }
    }


    addToQue(event) {
        if (this.playlist || this.artist) {
            event.stopPropagation();
            event.preventDefault();
            this.getTracks();
            return;
        }
        this.blockUI.start('Loading, please wait...');
        event.stopPropagation();
        event.preventDefault();
        if(this.onlineOffline1){
            this.playerService.addTrack(this.song);
        }
        this.blockUI.stop();
    }

    addTrack() {
        for (let i = 0; i < this.songs.length; i++) {
            let isAlreadyInPlaylist = this.playerService.isTrackAlreadyInQueue(this.songs[i]);//setting up for the first time...
            if (!isAlreadyInPlaylist) {
                if (this.playlist && this.playlist.type == "R") {
                    let cs = this.playerService.getRadioCurrentSong1(this.playlist.radioUrl);
                    if (cs == this.songs[i].id) {
                        this.playerService.addTrack(this.songs[i]);
                        this.blockUI.stop();
                        return;
                    }

                }
                else {
                    this.playerService.addTrack(this.songs[i]);
                }
            }
        }
    }

    removeTracks() {
        for (let i = 0; i < this.songs.length; i++) {
            this.playerService.removeSong(this.songs[i]);
        }
    }

    removeFromQue(event) {
        if (this.playlist || this.artist) {
            event.stopPropagation();
            event.preventDefault();
            this.getTracks(false);
            return;
        } else if (this.song._type == 'song') {
            this.blockUI.start('Loading, please wait...');
            event.stopPropagation();
            event.preventDefault();
            if (this.onlineOffline1){
                this.playerService.removeSong(this.song);
            }
            this.playerService.songRemovedFromQueue.next(true);
        }

        /*
            * IF WE CLEAR QUEUE ,THEN IT WILL CLOSE NAV AND PLAYER .
            */
        if (this.playerService.plyalistLength() == 0) {
            this.playerService.stop();
            this.playerService.setCurrentTrack(null);
            this.playerService.clearPlaylist(() => {
                //cleared playlist
            });
            this.scrollService.closeSideNav();
        }
        this.blockUI.stop();
    }


}



// WEBPACK FOOTER //
// ./src/app/songs/add-to-queue/add-to-queue.component.ts